import { faPeopleCarry } from '@fortawesome/pro-duotone-svg-icons';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { LinkButton } from 'components/atoms/button';
import { CardEmptyState, EmptyStateIcon } from 'components/atoms/empty-state';

export const MembersEmptyList: FC = () => {
  return (
    <>
      <CardEmptyState
        className="invite-modal--empty-state"
        image={<EmptyStateIcon icon={faPeopleCarry} />}
        message={
          <>
            <FormattedMessage id="invitation.team_member.empty" />{' '}
            <LinkButton className="invite-modal--cta">
              <FormattedMessage
                id="invite.with.label"
                values={{ label: 'people' }}
              />
            </LinkButton>
          </>
        }
      />
    </>
  );
};
